// api should be here
import { http } from '@/utils/http';
import qs from 'qs';
// 活动api baseurl
const urlPrefix = 'vote/2026project/q2/2026economics/controller.php?enews=';


const getBaseInfo = () => {
  return http.get(`${urlPrefix}base-info`);
};

// 新闻
const TEST_API = 'https://t8-testapi-proxy.cqcb.com';
const PRO_API = 'https://t8-api-proxy.cqcb.com';

const getNewsList = (data: any) => {
  let path = '';
  if (process.env.VUE_APP_ENV_NAME === 'development') {
    path = '/wap/api/v1/newsListColumn';
  } else if (process.env.VUE_APP_ENV_NAME === 'TEST') {
    path = TEST_API + '/api/v1/newsListColumn';
  } else if (process.env.VUE_APP_ENV_NAME === 'production') {
    path = PRO_API + '/api/v1/newsListColumn';
  }
  return http.get(path, { params: data });
};

const getRules = (type: any) => {
  const data: any = {
    1: `<p>为全面贯彻落实党的二十大和二十届历次全会精神，深入贯彻落实习近平总书记视察重庆重要讲话重要指示精神，重庆日报报业集团联合两江新区开展2026“十大重庆经济年度人物”评选活动，展示重庆企业家群体在推动科技创新、产业升级、乡村振兴、践行绿色发展理念等方面所取得的显著成就，激励更多市场主体在建设现代化新重庆的征程中奋勇争先，为“十五五”开好局、起好步积蓄磅礴力量。</p>`,
      2: `<p>1.指导单位</p>
<p>中共重庆市委组织部、中共重庆市委宣传部、中共重庆市委统战部、中共重庆市委社会工作部</p>
<p>2.主办单位</p>
<p>重庆日报报业集团、中共重庆市两江新区区委、重庆市两江新区人民政府</p>
<p>3.组委会成员单位</p>
<p>重庆市委金融办、重庆市发展改革委、重庆市科技局、重庆市经济信息委、重庆市人力社保局、重庆市规划自然资源局、重庆市住房城乡建委、重庆市城市管理局、重庆市交通运输委、重庆市农业农村委、重庆市商务委、重庆市文化旅游委、重庆市国资委、重庆市大数据发展局、重庆市工商联</p>
<p>4.承办单位</p>
<p>上游新闻、中共重庆市两江新区区委宣传部、中共重庆市两江新区区委统战部、重庆市两江新区发展改革委</p>`,
    3: `
<p>（一）人物类</p>
<p>2026十大重庆经济年度人物</p>
<p>2026十大重庆经济年度创新人物</p>
<p>2026十大两江新区经济年度人物</p>
<p>（二）案例类</p>
<p>2026成渝地区双城经济圈协同发展创新十大案例</p>
<p>2026重庆新质生产力培育创新十大案例</p>`,
    4: `<p>2025年紧扣国家重大战略部署，深度融入成渝地区双城经济圈建设，在推进新时代西部大开发中发挥支撑作用；以发展新质生产力为关键着力点，扎实推动科技创新与产业创新深度融合，加快构建现代化产业体系，努力在现代化新重庆建设中展现更大担当作为；全力打造具有“西部领先、全国进位和重庆辨识度”的标志性改革成果。</p>
    <p><strong>1.人物类</strong></p>
<p>（1）基本条件</p>
<p>① 遵守国家法律，坚持正确政治方向，践行社会主义核心价值观，具有良好的职业道德和行业声誉，弘扬企业家精神，在“增强爱国情怀”“勇于创新”“诚信守法”“承担社会责任”“拓展国际视野”等方面不断自我提升，做爱国敬业、守法经营、创业创新、回报社会的典范；践行亲清政商关系，模范遵守宪法法律法规，个人无严重违纪违法行为。</p>
<p>② 2025年1月1日起，在同一企业担任董事长、总裁、总经理等主要领导职务，推动企业发挥更大作用实现更大发展，带领团队在关键核心技术、颠覆性创新上取得重大进展或突破；</p>
<p>③ 具有良好的社会声誉，个人及所在单位无不良会计信用、纳税信用和银行信用记录及其他违规违法行为，近三年内无重大安全、质量、环境污染事故及重大劳资领域纠纷。</p>
<p>（2）具体条件</p>
<p>① “十大重庆经济年度人物”</p>
<p>参评人所在企业须为在重庆注册并实际开展业务的法人企业，在创造产值、税收贡献、吸纳就业、行业引领、产业升级、企业出海等方面取得良好成效或行业领先地位。企业2025年度营业收入5亿元以上，并持续保持盈利增长，纳税金额3000万元（含）以上。对农业、现代服务业企业，可适用以下标准：2025年度营业收入2亿元以上，纳税金额300万元以上。</p>
<p>② “十大重庆经济年度创新人物”</p>
<p>参评人所在企业须为在重庆注册并实际开展业务的法人企业，2025年度营业收入3000万元以上。在推动传统产业改造升级，开辟战略性新兴产业与未来产业新赛道，培育增长新动能等方面有突出表现。科技型企业须满足年度研发经费投入强度不低于3%；农业、非高技术服务业创新企业如不符合上述研发投入要求，但曾参与行业标准制定或拥有核心技术发明专利，可适当放宽研发经费投入条件。</p>
<p>③ “十大两江新区经济年度人物”</p>
<p>参评人所在企业须为在两江新区注册并实际开展业务的法人企业，企业在推动新质生产力发展、实施科技创新与产业创新深度融合、激发市场内生动力、深化区域协同联动、提升城市功能品质等一个或多个领域成效卓著，在行业对两江新区及重庆市经济社会高质量发展作出突出贡献，2025年度营业收入、纳税金额在同行业处于领先。</p>
<p>④ 参与以上三项评选，“西部领先、全国进位和重庆辨识度”标志性改革成果特别突出者，可适当放宽条件。</p>
<p><strong>2.案例类</strong></p>
<p>（1）成渝地区双城经济圈协同发展创新十大案例</p>
<p>聚焦纵深推进成渝地区双城经济圈建设，实施重点领域关键环节集成深化改革、欧亚大陆综合枢纽共建、西部金融中心建设提质，协同建设现代产业体系，提质发展川渝产业合作示范园区，布局建设成渝双城低空经济走廊，打造沿江产业转移示范区，建设巴蜀文化旅游走廊，加快实施“十项行动”“四张清单”，协同推进川渝共建重点项目，强化川渝公共服务共建共享，推动政务服务“川渝通办”迭代升级，推动双核联动联建和成渝中部崛起，加快建设成渝综合性国家科学中心等方面涌现出的各类新机制、新模式、新成果，政府部门及各类市场主体均可报名参与。</p>
<p>（2）重庆新质生产力培育创新十大案例</p>
<p>聚焦因地制宜发展新质生产力，推进“203060”重点攻坚突破体系，打造“9611”现代服务业产业体系，紧扣“416”科技创新布局和“33618”现代制造业集群体系融合发展需求，以科技创新引领全面创新，推动科技创新和产业创新深度融合。加速突破核心技术，促进科技成果高效转化，推动战略性新兴产业建链强链，布局未来产业新赛道。提升全要素生产率，创新数据要素配置机制，优化人才引育留用全链条生态，完善新质生产力发展配套政策，在重大技术创新突破、生产要素创新性配置、产业深度转型升级等方面涌现出的新机制、新模式、新成果，政府部门及各类市场主体均可报名参与。</p>`,
    5: `<p>1.经济贡献力</p>
<p>2.创新变革力</p>
<p>3.行业带动力</p>
<p>4.企业治理力</p>
<p>5.绿色发展力</p>
<p>6.社会影响力</p>`,
    6: `<p>1.广泛征集</p>
<p>2.资格审查</p>
<p>3.实地探访</p>
<p>4.参评展示</p>
<p>5.专家评审</p>
<p>6.终审公示</p>
<p>7.颁奖典礼</p>`,
  };
  return data[type];
};

export {
  getBaseInfo,
  getRules,
  getNewsList,
};
